import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import ConfirmDialog from "components/common/ConfirmDialog";
import { ErrorOutlinedButton, ErrorTextButton } from "components/common/CustomButtons";
import LoadingFullScreen from "components/common/LoadingFullScreen";
import { ACTION_STATES } from "core/actions";
import { DELETE_CONFIRMATION_MESSAGE } from "core/dataConstants";
import { assertString } from "core/validation";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as listActions } from "./logic/filmListActions";

const componentStyles = makeStyles((theme) => ({
    errorMessage: {
        color: theme.palette.error.main,
    },
}));

export function DeleteFilmBtn({ btnProps, filmReleaseId, onDelete, filName }) {
    const classes = componentStyles();

    const _btnProps = Object.assign(
        {},
        {
            variant: "outlined",
            size: "small",
        },
        btnProps
    );

    const [showConfirm, setShowConfirm] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);
    const [confirmationMessage, setConfirmationMessage] = React.useState(null);
    const [showInputError, setShowInputError] = React.useState(false);

    const deleteStatus = useSelector((state) => state.filmReleaseList.deleteStatus);
    const dispatch = useDispatch();
    React.useEffect(() => {
        if (deleting && deleteStatus !== ACTION_STATES.SEND) {
            setDeleting(false);
            if (deleteStatus === ACTION_STATES.SUCCESS) {
                handleClose();
                onDelete();
            }
        }
    }, [deleteStatus, deleting, onDelete]);

    function deleteFilm() {
        if (!deleting) {
            setDeleting(true);
            dispatch(listActions.ON_DELETE_FILM.send({ id: filmReleaseId, confirmationMessage }));
        }
    }

    function handleOnClick() {
        setShowConfirm(true);
    }
    function handleClose() {
        setShowInputError(false);
        setShowConfirm(false);
        setConfirmationMessage(null);
    }
    function handleDelete() {
        if (!assertString(confirmationMessage) || DELETE_CONFIRMATION_MESSAGE !== confirmationMessage.toUpperCase()) {
            setShowInputError(true);
        } else {
            setShowConfirm(false);
            setDeleting(true);
            deleteFilm();
        }
    }

    function handleConfirmationOnchange(e) {
        setShowInputError(false);
        setConfirmationMessage(e.target.value);
    }

    const message = (
        <>
            <Typography gutterBottom variant={"subtitle1"}>
                Deletion of a title will also permanently remove all information related to it!
            </Typography>
            <Typography gutterBottom variant={"subtitle1"}>
                Please consider merging the title into the one.
            </Typography>
            <Typography variant={"subtitle2"}>{`If you are confident in deletion of film ${filName}`}</Typography>
            <div>
                <Typography variant={"subtitle2"}>Please type in word DELETE</Typography>
                <TextField
                    variant={"outlined"}
                    value={confirmationMessage}
                    error={showInputError}
                    onChange={handleConfirmationOnchange}
                />
                {showInputError && <Typography className={classes.errorMessage}>Please enter confirmation</Typography>}
            </div>
        </>
    );
    return (
        <>
            <ErrorOutlinedButton {..._btnProps} onClick={handleOnClick} startIcon={<DeleteOutlineOutlinedIcon />}>
                Delete
            </ErrorOutlinedButton>
            <ConfirmDialog
                open={showConfirm}
                message={message}
                btnConfirm={<ErrorTextButton onClick={handleDelete}>Delete</ErrorTextButton>}
                closeText="Close"
                onConfirm={handleDelete}
                onCancel={handleClose}
            />
            <LoadingFullScreen open={deleting} loadingMessage={"Deleting FilmRelease..."} />
        </>
    );
}
